import React from "react";
import ListagemAI from "./TiposDemonstrativos/ListagemAI";
import ListagemAM from "./TiposDemonstrativos/ListagemAM";
import ListagemD from "./TiposDemonstrativos/ListagemD";
import ListagemE from "./TiposDemonstrativos/ListagemE";
import ListagemJ1 from "./TiposDemonstrativos/ListagemJ1";
import ListagemM from "./TiposDemonstrativos/ListagemM";
import ListagemP from "./TiposDemonstrativos/ListagemP";
import ListagemQ from "./TiposDemonstrativos/ListagemQ";
import ListagemR from "./TiposDemonstrativos/ListagemR";
import ListagemS from "./TiposDemonstrativos/ListagemS";
import ListagemU from "./TiposDemonstrativos/ListagemU";
import ListagemV from "./TiposDemonstrativos/ListagemV";
import ListagemDebitoExtrato from "./TiposDemonstrativos/ListagemDebitoExtrato";
import ListagemDebitoExtratoMulta from "./TiposDemonstrativos/ListagemDebitoExtratoMulta";

const TelaTipoDemonstrativo = ({
  hidden,
  tipoDetalhamento,
  sqItemOcorrencia,
  sqAcaoFiscal,
  dadosOcorrencia,
  history,
}) => {
  const tiposDebitoExtrato = ["BV", "BT", "BX", "BW", "BU", "BD", "B5", "BY", "BZ", "B", "B2", "B3", "B4"];
  const tiposDebitoExtratoMulta = ["TD", "TP", "TQ", "TR", "TT", "TS", "TU", "TX", "TV", "TY", "TZ"];
  const tiposDetalhamentoQ = ["Q", "Q1", "Q2", "Q3"];
  const tiposDetalhamentoD = ["D", "D1", "D2"];
  return (
    <div hidden={hidden}>
      {(() => {
        const tipo = tipoDetalhamento ?? history?.location.state.tipoDetalhamento;

        if (tiposDebitoExtrato.includes(tipo)) {
          return (
            <ListagemDebitoExtrato
              history={history}
              sqItemOcorrencia={sqItemOcorrencia}
              sqAcaoFiscal={sqAcaoFiscal}
              dadosOcorrencia={dadosOcorrencia}
              tipoDetalhamento={tipoDetalhamento}
            />
          );
        }

        if (tiposDebitoExtratoMulta.includes(tipo)) {
          return (
            <ListagemDebitoExtratoMulta
              history={history}
              sqItemOcorrencia={sqItemOcorrencia}
              sqAcaoFiscal={sqAcaoFiscal}
              dadosOcorrencia={dadosOcorrencia}
              tipoDetalhamento={tipoDetalhamento}
            />
          );
        }

        if (tiposDetalhamentoQ.includes(tipo)) {
          return (
            <ListagemQ
              history={history}
              sqItemOcorrencia={sqItemOcorrencia}
              sqAcaoFiscal={sqAcaoFiscal}
              dadosOcorrencia={dadosOcorrencia}
              tipoDetalhamento={tipoDetalhamento}
            />
          );
        }

        if (tiposDetalhamentoD.includes(tipo)) {
          return (
            <ListagemD
              history={history}
              sqItemOcorrencia={sqItemOcorrencia}
              sqAcaoFiscal={sqAcaoFiscal}
              dadosOcorrencia={dadosOcorrencia}
              tipoDetalhamento={tipoDetalhamento}
            />
          );
        }

        switch (tipo) {
          case "AI":
            return (
              <ListagemAI
                history={history}
                sqItemOcorrencia={sqItemOcorrencia}
                sqAcaoFiscal={sqAcaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
              />
            );

          case "AM":
            return (
              <ListagemAM
                history={history}
                sqItemOcorrencia={sqItemOcorrencia}
                sqAcaoFiscal={sqAcaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
              />
            );
          case "E":
            return (
              <ListagemE
                history={history}
                sqItemOcorrencia={sqItemOcorrencia}
                sqAcaoFiscal={sqAcaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
              />
            );

          case "J1":
            return (
              <ListagemJ1
                history={history}
                sqItemOcorrencia={
                  sqItemOcorrencia === undefined ? history?.location.state.sqItemOcorrencia : sqItemOcorrencia
                }
                sqAcaoFiscal={sqAcaoFiscal === undefined ? history?.location.state.sqAcaoFiscal : sqAcaoFiscal}
                dadosOcorrencia={
                  dadosOcorrencia === undefined ? history?.location.state.dadosOcorrencia : dadosOcorrencia
                }
              />
            );

          case "M":
            return (
              <ListagemM
                history={history}
                sqItemOcorrencia={sqItemOcorrencia}
                sqAcaoFiscal={sqAcaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
              />
            );

          case "P":
            return (
              <ListagemP
                history={history}
                sqItemOcorrencia={sqItemOcorrencia}
                sqAcaoFiscal={sqAcaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
              />
            );
          case "U":
            return (
              <ListagemU
                history={history}
                sqItemOcorrencia={sqItemOcorrencia}
                sqAcaoFiscal={sqAcaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
              />
            );
          case "S":
            return (
              <ListagemS
                history={history}
                sqItemOcorrencia={sqItemOcorrencia}
                sqAcaoFiscal={sqAcaoFiscal}
                dadosOcorrencia={dadosOcorrencia}
              />
            );
          case "R":
            return (
              <ListagemR
                history={history}
                sqItemOcorrencia={
                  sqItemOcorrencia === undefined ? history?.location.state.sqItemOcorrencia : sqItemOcorrencia
                }
                sqAcaoFiscal={sqAcaoFiscal === undefined ? history?.location.state.sqAcaoFiscal : sqAcaoFiscal}
                dadosOcorrencia={
                  dadosOcorrencia === undefined ? history?.location.state.dadosOcorrencia : dadosOcorrencia
                }
              />
            );
          case "R2":
            return (
              <ListagemR
                history={history}
                sqItemOcorrencia={
                  sqItemOcorrencia === undefined ? history?.location.state.sqItemOcorrencia : sqItemOcorrencia
                }
                sqAcaoFiscal={sqAcaoFiscal === undefined ? history?.location.state.sqAcaoFiscal : sqAcaoFiscal}
                dadosOcorrencia={
                  dadosOcorrencia === undefined ? history?.location.state.dadosOcorrencia : dadosOcorrencia
                }
              />
            );
          case "V":
            return (
              <ListagemV
                history={history}
                sqItemOcorrencia={
                  sqItemOcorrencia === undefined ? history?.location.state.sqItemOcorrencia : sqItemOcorrencia
                }
                sqAcaoFiscal={sqAcaoFiscal === undefined ? history?.location.state.sqAcaoFiscal : sqAcaoFiscal}
                dadosOcorrencia={
                  dadosOcorrencia === undefined ? history?.location.state.dadosOcorrencia : dadosOcorrencia
                }
              />
            );
          default:
            return null;
        }
      })()}
    </div>
  );
};

export default TelaTipoDemonstrativo;
